<div class="notification-container" *ngIf="hasNotifications()"></div>
